<template>
  <component :is="colWrapper" v-bind="colProps">
    <validation-provider
      v-slot="validationContext"
      :name="validation_field_name || label"
      :rules="rules"
    >
      <b-form-group :label="label" :label-for="id">
        <b-form-input
          :id="id"
          :value="value"
          :placeholder="placeholder"
          :disabled="disabled"
          :type="type"
          :state="getValidationState(validationContext)"
          @input="$emit('input', $event)"
        />
        <b-form-invalid-feedback>
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>
  </component>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { watch, computed } from "@vue/composition-api";

export default {
  name: "BaseInput",
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      default: "",
    },
    validation_field_name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    cols: {
      type: [String, Number],
      default: null,
    },
    getValidationState: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    const colWrapper = computed(() => (props.cols ? "b-col" : "div"));

    const colProps = computed(() => (props.cols ? { cols: props.cols } : {}));

    return {
      colProps,
      colWrapper,
    };
  },
};
</script>

